/**
 * The home's questions, in the proof page's words: the offer and the own-muse lines are imported from `proof/spec.ts`,
 * the numbers from `proposition.ts`, so a price or an allowance changes here when it changes there.
 */
import {FREE_ALLOWANCE, FRONT_LINE} from '@product/ovid/proposition'
import {CLOSING_BODY, OWN_MUSE_BODY} from '@product/ovid/proof/spec'

export type FaqEntry = {question: string; answer: string}

export const homeFaq: FaqEntry[] = [
    {question: 'What is Ovid?', answer: FRONT_LINE},
    {
        question: 'Who are the women in the pictures?',
        answer:
            "Ovid's muses: women designed by the house, not real people. Choose one and every picture you make shows her, " +
            'with the same face. Until you choose, the house chooses one for you. You can change her at any time.',
    },
    {question: 'Can I make a woman of my own?', answer: `Yes. ${OWN_MUSE_BODY}`},
    {
        question: 'Is anyone in these pictures real?',
        answer:
            "No one in the house's pictures is real. A woman of your own is made from the photos you send, with her " +
            'consent, which you confirm when you send them.',
    },
    {question: 'What does it cost?', answer: `Browsing the wall is free. ${CLOSING_BODY} Cancel any time.`},
    {
        question: 'Why are some pictures blurred?',
        answer: `A visitor sees the first ${FREE_ALLOWANCE} pictures of the wall clear and the rest blurred. Sign in to see them all.`,
    },
    {
        question: 'Where are the terms?',
        answer: 'See Terms and Privacy for the full rules, reachable from every page.',
    },
]
